import React, { useState, useEffect } from "react";
import classes from "./sesearcheventparent.module.scss";
import {
    FormControl,
    TextField,
    Button,
    Grid
  } from '@mui/material';
    
import { Icon,DatePicker } from '@genesis/ui-kit';
import axios from "axios";
import axiosInstance from "../../../../Shared/Utill/AxiosConfig";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import { methods } from "underscore";
import { useNavigate, NavLink,useLocation } from "react-router-dom";
import { constants } from "../../../../Shared/Url/Constants";
import { CheckIsUserAdmin, convertDateToMMDDYYYYString } from "../../../../Shared/Utill/Utills";
import AdminControlsDataGrid from '../../AdminControlsDataGrid';
import UnpublishedOutlinedIcon from '@mui/icons-material/UnpublishedOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import SnackBar from "../../../../Shared/Snackbar/Snackbar";
import DivisionDropDownComp from "../../DivisionDropdown/DivisionDropdownComp";
import { AddPlusIcon } from "../../../../Resources/availabilityicon/IconUtils";
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreHoriz';
import EventLocationsDialog from "../EventLocationsList/EventLocationsDialog";
import DeleteEventDialog from "../DeleteEvent/DeleteEventDialog";
import DuplicateEventDialog from "../DuplicateEvent/DuplicateEventDialog";

const SearchParentEventControlPage = () => {
    const personDetails = useSelector((state) => state.personStatic.personStaticData);
    const urlDetails = useSelector((state) => state.url.urlData);
    const token = Cookies.get('X_TKN');
    const navigate = useNavigate();
    const [divSelectedValue, setDivSelectedValue] = useState(null);
    const [eventName, setEventName] = useState("");
    const [eventId, setEventId] = useState("");
   
    const [searchApiValue, setSearchApiValue] = useState([]);
    const [isAlertOpen, setAlertOpen] = React.useState({});
    const { message, severity, open } = isAlertOpen || {};
    const [searchValue, setSearchValue] = useState([]);
    
    const ITEM_HEIGHT = 48;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const openOption = Boolean(anchorEl);

    const [openLocDialog, setOpenLocDialog] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [selectedLocLinkData, setSelectedLocLinkData] = useState(null);
    const [options, setMenuOptions] = useState([
      'Edit',
      'Bulk Update',
      'Duplicate',
      'Delete',    
    ]);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [openDuplicateDialog, setOpenDuplicateDialog] = useState(false);

    const location = useLocation();

    // check user role at page
    CheckIsUserAdmin();

    useEffect(() => {
      
      let isDeleteSuccess = location.state!==null ? location.state : false;
      if(isDeleteSuccess){
        setAlertOpen({
          open: true,
          severity: "success",
          message : "Event deleted successfully.",
        })
      }
    },[]);

  const onDivDropDownSelect = (selectedDivision) => {
    setDivSelectedValue(selectedDivision);
  }
  

  const handleAlertNotifClose = () => {
     setAlertOpen({});
  };

  // option menu callbacks
  const handleClick = (event,data) => {
      setAnchorEl(event.currentTarget);
      setSelectedRowData(data);
    };

  const handleClose = (event) => {
      setAnchorEl(null);
    };

  const handleOptionMenuClick = (event) => {
      setAnchorEl(null);
      let optionClicked = event.nativeEvent.target.outerText;
      let myData = selectedRowData;
      if(optionClicked == 'Edit'){
        navigate("Edit", { state: {data: myData, flag: "E"}});
      }
      if(optionClicked == 'Bulk Update'){
        navigate("BulkUpdate", { state: {data: myData, flag: "E"}});
      }
      if(optionClicked == 'Delete'){
        setOpenDeleteDialog(true);
      }
      if(optionClicked == 'Duplicate'){
        setOpenDuplicateDialog(true);
      }
    }
  //------
    const handleSearch = () => {
      let searchData = [];
      
      if(divSelectedValue === null) {
        setAlertOpen({
          open: true,
          severity: "error",
          message : "Please Select Division",
        })
      }
       else {
        let data = {
        divNbr: divSelectedValue.divNbr,
        eventName: eventName != "" ? eventName : null,
        displayDiv: divSelectedValue.divNbr + " - " + divSelectedValue.divName,
    }

     axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_EVENT_CONTROL_GET_EEVNT_CONTROL_LOCATION}`, 
     data,
      {
        headers:{
        'Content-Type': 'application/json',
        'Authorization':'Bearer ' + token,
        }
      }).then((res) => {
        let tmparr = []

       console.log("response",res.data);
       res.data.map(obj => {
        let tmpobj = {}
        console.log("obj",obj)
        tmpobj.id = obj.eventid;
        tmpobj.divnbr = obj.divnbr;
        tmpobj.division = obj.displayDiv;
        tmpobj.eventname = obj.eventname;
        tmpobj.eventid = obj.eventid;
        tmpobj.location_count = obj.location_count;
        tmparr.push(tmpobj);
      });
      setSearchApiValue(res.data);
      setSearchValue(tmparr);
      }).catch((err) => {
       setAlertOpen({
          open: true,
          severity: "error",
          message : "Something went wrong",
        })
      });
       }
      
    }
    
  const handleLocClick = (rowdata) => {
    console.log("Locations Clicked" + JSON.stringify(rowdata) );
    setOpenLocDialog(true);
    setSelectedLocLinkData(rowdata);
  }

      
  const onCloseDialog = () => {
    setOpenLocDialog(false);
    setOpenDeleteDialog(false);
    setOpenDuplicateDialog(false);
  }

  const onDeleteCallback = (responseType,message) => {
    onCloseDialog();
    //handle success / failue
    setAlertOpen({
      open: true,
      severity: responseType,
      message : message,
    });
    // refresh data
    if(responseType == 'success'){
      handleSearch();
    }
  }

  const onDuplicateCallback = (responseType,message,resp) => {
    onCloseDialog();
    //handle success / failue
    setAlertOpen({
      open: true,
      severity: responseType,
      message : message,
    });
    // refresh data
    if(responseType == 'success'){
      handleSearch();
    }
  }

  
  const columns = [
    { field: 'division', headerName: 'Division', width: "130" },
    { field: 'eventname', headerName: 'Event Name', width: "400"},
    { field: 'eventid', headerName: 'Event ID', width: "110" },
    { field: 'location_count', headerName: 'Location(s)', width: "110", renderCell: (params) => {
      let rowdata = params.row;
      return( <u className={classes.location_link} onClick={() => handleLocClick(rowdata)}>{params.row.location_count}</u>) 
    }
   },

    { field: 'actions', headerName: 'Actions', width: "130", renderCell: (params) => {
      let data= params.row;
      return( <div>
    <IconButton
      aria-label="more"
      id="long-button"
      aria-controls={openOption ? 'long-menu' : undefined}
      aria-expanded={openOption ? 'true' : undefined}
      aria-haspopup="true"
      onClick={(event) => handleClick(event, data)}
    >
      <MoreVertIcon /> <div></div>
    </IconButton>
    <Menu
      id="long-menu"
      MenuListProps={{
        'aria-labelledby': 'long-button',
      }}
      anchorEl={anchorEl}
      open={openOption}
      onClose={handleClose}
      PaperProps={{
        style: {
          maxHeight: ITEM_HEIGHT * 4.5,
          width: '15ch',
        },
      }}
    >
      {options.map((option) => (
        <>
         {(selectedRowData && (selectedRowData.location_count > 0) || (selectedRowData == null || option === "Edit" || option === "Delete")) &&
        <MenuItem key={option} value={option} className={classes.menu_item} onClick={(event) => handleOptionMenuClick(event)} >
          {option}
        </MenuItem>
        }
        </>

      ))}
    </Menu>
   </div>)
    
      }},
    
  ];
 
return(<div className={classes.pagemargin}>
        <div className={classes.pagetitle}>Event Controls</div> 
        <div className={classes.icon_text_wrap}>
            <div  className={classes.icon_text}>
                <AddPlusIcon />
                <NavLink
                    to="Add" 
                    style={{textDecoration: "underline"}}
                    state={{  flag: "A" }}
                    className={classes.label_text}>
                    Add
                </NavLink>
             </div> 
        </div>
     
        <div className={classes.searchbox}>
        <SnackBar
        open={open}
        message={message}
        severity={severity}
        onClose={handleAlertNotifClose}
        ></SnackBar>

    <Grid container spacing={3}>        
    <Grid key={0} item xs={2}>
      <DivisionDropDownComp
      onDivChange={e => onDivDropDownSelect(e)}>
      </DivisionDropDownComp>
    </Grid>
    <Grid key={1} item xs={2}>
     <FormControl  style={{minWidth: '100%'}}>
      <TextField 
      label="Event Name (Opt)"
      onChange={(e) => setEventName(e.target.value)}
      value={eventName}
       />
    </FormControl>
    </Grid>
  
  
    <Grid key={2} item xs={4}>
     <Button style={{
                marginLeft: "10px",
                paddingTop: "14px",
                paddingBottom: "14px",
                paddingLeft: "80px",
                paddingRight: "80px",
                marginRight: "5px"
              }} onClick={handleSearch}>Search</Button>
     </Grid>         
    </Grid> 

    </div>
    <AdminControlsDataGrid columns= { columns} rows = {searchValue} width={"90%"} height={600} disableSelectionClick={true} />          
    {openLocDialog && <EventLocationsDialog onCloseDialog={onCloseDialog} data={selectedLocLinkData}/>}
    {openDeleteDialog && <DeleteEventDialog onCloseDialog={onCloseDialog} onDeleteCallback={onDeleteCallback} data={selectedRowData.eventid}/>}
    {openDuplicateDialog && <DuplicateEventDialog onCloseDialog={onCloseDialog} onDuplicateCallback={onDuplicateCallback} eventId={selectedRowData.eventid} eventName={selectedRowData.eventname}/>}


  </div>); 
}

export default SearchParentEventControlPage;